import axios from "axios";
import { gtagEvent } from "@/lib/gtag";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackEvent(type) {
  axios.post(`${API}/events`, { type }).catch(() => {});
}

// Counts each visitor once per browser session
export function trackOnce(type) {
  const key = `att_evt_${type}`;
  if (window.sessionStorage.getItem(key)) return;
  window.sessionStorage.setItem(key, "1");
  trackEvent(type);
}

export function hasTracked(type) {
  return Boolean(window.sessionStorage.getItem(`att_evt_${type}`));
}

// Fired after a successful booking: Ads conversion + calc-attribution event.
export function trackBookingConversion() {
  gtagEvent("booking_success");
  if (hasTracked("calc_used")) trackOnce("booking_after_calc");
}
